import { render, staticRenderFns } from "./CreateVendorModal.vue?vue&type=template&id=e622017c&scoped=true"
import script from "./CreateVendorModal.vue?vue&type=script&lang=js"
export * from "./CreateVendorModal.vue?vue&type=script&lang=js"
import style0 from "./CreateVendorModal.vue?vue&type=style&index=0&id=e622017c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e622017c",
  null
  
)

export default component.exports